import { Link } from 'react-router-dom'
import { Home, Keyboard, Target, TrendingUp } from 'lucide-react'

export default function About() {
  return (
    <div className="min-h-screen bg-black text-white" style={{ background: '#000000' }}>
      <nav className="px-6 py-4 border-b border-gray-800">
        <div className="max-w-7xl mx-auto flex items-center gap-4">
          <Link to="/" className="text-gray-400 hover:text-white transition-colors">
            <Home className="w-6 h-6" />
          </Link>
          <h1 className="text-2xl font-bold text-white">About Typir</h1>
        </div>
      </nav>
      
      <div className="max-w-4xl mx-auto px-8 py-12">
        <div className="stat-card rounded-2xl p-8 border space-y-8">
          <div>
            <h2 className="text-3xl font-bold text-white mb-4">About Typir</h2>
            <p className="text-gray-400 text-lg leading-relaxed">
              Typir is a specialized typing practice platform designed for developers and programmers. Unlike traditional typing tutors, Typir focuses on coding-specific keywords and syntax from popular programming languages.
            </p>
          </div>
          
          <div>
            <h3 className="text-2xl font-bold text-white mb-4">Why Typir?</h3>
            <p className="text-gray-400 leading-relaxed mb-4">
              Most typing practice tools use random words or common English phrases. As developers, we type different patterns - variable names, function calls, keywords, and symbols. Typir helps you practice what you actually type when coding.
            </p>
          </div>
          
          <div className="grid md:grid-cols-3 gap-6">
            <div className="bg-black rounded-xl p-6 border border-gray-800">
              <div className="w-12 h-12 bg-green-900 rounded-lg flex items-center justify-center mb-4">
                <Keyboard className="w-6 h-6 text-green-500" />
              </div>
              <h4 className="text-lg font-bold text-white mb-2">Coding Keywords</h4>
              <p className="text-gray-400 text-sm">
                Practice with real coding words from Python, JavaScript, Java, Swift, and more.
              </p>
            </div>
            
            <div className="bg-black rounded-xl p-6 border border-gray-800">
              <div className="w-12 h-12 bg-green-900 rounded-lg flex items-center justify-center mb-4">
                <Target className="w-6 h-6 text-green-500" />
              </div>
              <h4 className="text-lg font-bold text-white mb-2">Progressive Learning</h4>
              <p className="text-gray-400 text-sm">
                Start from alphabet 'a' and progress through 26 lessons with increasing difficulty.
              </p>
            </div>
            
            <div className="bg-black rounded-xl p-6 border border-gray-800">
              <div className="w-12 h-12 bg-green-900 rounded-lg flex items-center justify-center mb-4">
                <TrendingUp className="w-6 h-6 text-green-500" />
              </div>
              <h4 className="text-lg font-bold text-white mb-2">Track Progress</h4>
              <p className="text-gray-400 text-sm">
                Monitor your WPM and accuracy. Save your progress with a free account.
              </p>
            </div>
          </div>
          
          <div>
            <h3 className="text-2xl font-bold text-white mb-4">Open Source</h3>
            <p className="text-gray-400 leading-relaxed">
              Typir is built with React, FastAPI, and Supabase. We believe in helping developers improve their skills with modern, effective tools.
            </p>
          </div>
          
          <Link to="/" className="btn-primary inline-block">
            Start Practicing
          </Link>
        </div>
      </div>
    </div>
  )
}
